// ISO 639 https://en.wikipedia.org/wiki/List_of_ISO_639_language_codes
export const supportedLanguages = [
    { code: 'en', name: 'English' },
    { code: 'de', name: 'Deutsch (German)' },
    { code: 'es', name: 'Español (Spanish)' },
    { code: 'fr', name: 'Français (French)' },
    { code: 'it', name: 'Italiano (Italian)' },
    { code: 'pl', name: 'Polski (Polish)' },
    { code: 'pt', name: 'Português (Portuguese)' },
    { code: 'uk', name: 'Українська (Ukrainian)' },
];